import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '@/lib/api/services/dashboard';
import type {
	DashboardContentStats,
	DashboardContentPerformance,
	DashboardOperationalStats,
} from '@/lib/api/types';

export const dashboardKeys = {
	all: ['dashboard'] as const,
	stats: () => [...dashboardKeys.all, 'stats'] as const,
	contentPerformance: () => [...dashboardKeys.all, 'content-performance'] as const,
};

export interface DashboardStatsData {
	content: DashboardContentStats;
	operational: DashboardOperationalStats;
}

export const useDashboardStats = () => {
	return useQuery<DashboardStatsData, Error>({
		queryKey: dashboardKeys.stats(),
		queryFn: async () => {
			const [contentResponse, operationalResponse] = await Promise.all([
				dashboardService.getContentStats(),
				dashboardService.getOperationalStats(),
			]);

			return {
				content: contentResponse.data,
				operational: operationalResponse.data,
			};
		},
		staleTime: 5 * 60 * 1000,
		placeholderData: (previousData) => previousData,
	});
};

export const useDashboardContentPerformance = () => {
	return useQuery<DashboardContentPerformance, Error>({
		queryKey: dashboardKeys.contentPerformance(),
		queryFn: async () => {
			const response = await dashboardService.getContentPerformance();
			return response.data;
		},
		staleTime: 5 * 60 * 1000,
		placeholderData: (previousData) => previousData,
	});
};